import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { pickBy } from "lodash-es";
import { useId } from "../../helpers/hooks";
import { Label } from "../label/Label";
export const RadioContext = /*#__PURE__*/React.createContext();
RadioContext.displayName = "RadioContext";

/**
 * removes unnecessary props
 */
function getContextProps({
  children: _children,
  label: _label,
  style: _style,
  ...context
} = {}) {
  return context;
}
export function getInputProps(context, props) {
  let isChecked = props.checked;
  if (context) {
    isChecked = props.value === context.value;
  }
  const inputProps = {
    ...getContextProps(context),
    // don't merge undefined props
    ...pickBy(props, value => value !== undefined),
    checked: isChecked
  };
  return inputProps;
}
const RadioGroup = ({
  required,
  label,
  className,
  vertical,
  ...props
}) => {
  const id = useId();
  const labelId = `tui-radio-group-${id}`;
  return /*#__PURE__*/React.createElement("div", {
    style: props.style
  }, label && /*#__PURE__*/React.createElement(Label, {
    id: labelId,
    required: required
  }, label), /*#__PURE__*/React.createElement("div", {
    "aria-required": required,
    className: classNames("tui-radio-group", className, {
      vertical
    }),
    role: "radiogroup",
    "aria-labelledby": label ? labelId : null
  }, /*#__PURE__*/React.createElement(RadioContext.Provider, {
    value: props
  }, props.children)));
};
RadioGroup.displayName = "RadioGroup";
RadioGroup.defaultProps = {
  style: {},
  label: undefined,
  required: false,
  className: "",
  vertical: false
};
RadioGroup.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  label: PropTypes.node,
  required: PropTypes.bool,
  className: PropTypes.string,
  vertical: PropTypes.bool
};
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map